import React, { useEffect, useState } from 'react';
import './VisibilitySettings.scss';
import { getVisibility, updateVisibility } from '../../../services/api/GlobalSettingsApi';
import { useAuth } from '../../../context/AuthContext';
import { useToast } from '../../../context/ToastContext';

const VisibilitySettings = () => {
  const { company, setCompany, visibility, setvisibility } = useAuth();
  const [settingvisibility, setSettingVisibility] = useState({});
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();

  const displayKeys = Object.keys(company?.rights || {}).filter(
    (key) => company.rights[key] === true
  );


  useEffect(() => {
    const fetchVisibility = async () => {
      try {
        const res = await getVisibility();
        if (res) setSettingVisibility(res.data);
      } catch (err) {
        console.error('Error fetching rights:', err);
        showToast('Failed to fetch visibility settings.', 'error');
      }
    };
    fetchVisibility();
  }, []);

  const handleToggle = (key) => {
    setSettingVisibility(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleSave = async () => {
    const payload = {
      cases: settingvisibility.cases ?? false,
      clients: settingvisibility.clients ?? false,
      expenses: settingvisibility.expenses ?? false,
      invoices: settingvisibility.invoices ?? false,
      labels: settingvisibility.labels ?? false,
      mobileAccess: settingvisibility.mobileAccess ?? false,
      notes: settingvisibility.notes ?? false,
      tasks: settingvisibility.tasks ?? false,
      teams: settingvisibility.teams ?? false,
      branch: settingvisibility.branch ?? false
    };

    setLoading(true);
    try {
      await updateVisibility({ visibility: payload });

      const updatedVisibility = {
        ...payload,
      };

      setvisibility(updatedVisibility);
      localStorage.setItem("visibility", JSON.stringify(updatedVisibility));
      showToast("Visibility updated successfully.", "success");
    } catch (err) {
      console.error("Error updating rights:", err);
      showToast("Something went wrong to update Rights!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <section className="rights-settings">
      <h3 className="rights-settings-title">Visibility Settings</h3>

      <div className="rights-settings-grid">
        {displayKeys.map((key) => (
          <div className="rights-settings-item" key={key}>
            <label>{key === 'mobileAccess' ? 'Mobile App Access' : key}</label>
            <input
              type="checkbox"
              checked={settingvisibility[key] || false}
              onChange={() => handleToggle(key)}
            />
          </div>
        ))}
      </div>

      <button
        className="rights-settings-save-btn"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save Visibility Changes'}
      </button>
    </section>
    </>
  );
}

export default VisibilitySettings;
